import React, { useEffect, useState } from 'react';
import ProjectTransitionFields from './ProjectTransitionFields';
import { projectTransitionSchema } from '../../../lib/project-transition-schemas';
import { api } from '../../../lib/api';

// Sprint D D.11 — replace the domain_id text input with a populated <select>
// sourced from the account's domains endpoint. Other fields continue to
// render via the schema-driven ProjectTransitionFields helper.

export default function DomainCutoverForm({ values, onChange, errors, accountId }) {
  const schema = projectTransitionSchema('domain_cutover');
  const [domains, setDomains] = useState([]);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    if (!accountId) return;
    let alive = true;
    // The domains list endpoint supports an account_id filter; there is no
    // /accounts/:id/domains sub-route (that path 404s).
    api.get(`/api/admin/domains?account_id=${encodeURIComponent(accountId)}`)
      .then((d) => { if (alive) setDomains(d.domains || d.rows || []); })
      .catch((err) => { if (alive) setLoadError(err?.data?.error || err?.message || 'Failed to load domains'); });
    return () => { alive = false; };
  }, [accountId]);

  // Render the select for domain_id outside the schema and pass the rest of
  // the fields to ProjectTransitionFields (filtered).
  const otherFields = schema.fields.filter((f) => f.key !== 'domain_id');
  const otherSchema = { ...schema, fields: otherFields };

  return (
    <div className="space-y-4">
      <label className="block">
        <span className="block text-[11px] uppercase tracking-wider text-gray-400/80 mb-1.5">Domain</span>
        <select
          data-testid="pfield-domain_id"
          value={values?.domain_id || ''}
          onChange={(e) => onChange({ ...values, domain_id: e.target.value })}
          className="w-full px-3 py-2 rounded-lg bg-white/[0.04] border border-white/[0.08] text-sm text-white"
        >
          <option value="">Select a domain…</option>
          {domains.map((d) => (
            <option key={d.id} value={d.id}>{d.domain || d.name || d.host || d.id}</option>
          ))}
        </select>
        {loadError && <p className="mt-1 text-[11px] text-red-400">{loadError}</p>}
      </label>
      <ProjectTransitionFields schema={otherSchema} values={values} onChange={onChange} errors={errors} />
    </div>
  );
}
